<template>
  <div class="update-dialog">
    <!-- 内容 -->
    <div v-if="inputVisible"
         class="text">{{ content || "-" }}</div>
    <template style="display:flex;"
              v-if="status">
      <el-date-picker class="up-input"
                      size="mini"
                      v-if="!inputVisible"
                      v-model="upContent"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期"
                      @blur="updeteTime"></el-date-picker>
      <!-- icon -->
      <div class="icon-font"
           @click="isShowInput">
        <ig-icon name="brush"></ig-icon>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Object,
    scope: Object,
  },
  data () {
    return {
      upContent: '',
      inputVisible: true,
    }
  },
  computed: {
    status () {
      return this.scope.row.orderStatus == 1 ? true : false
    },
    content () {
      return this.scope.row[this.tableData.bind]
    },
  },

  methods: {
    // 显示input
    isShowInput () {
      this.upContent = this.content
      this.inputVisible = false
    },
    // 修改时间
    updeteTime () {
      let { content, upContent } = this
      if (content === upContent) {
        this.$message({
          message: '请修改时间',
        })
      } else {
        this.tableData.isShowDia(this.scope.row, upContent)
      }
      this.inputVisible = true
    },
  },
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector('input').focus()
      },
    },
  },
}
</script>

<style scoped lang="scss">
.update-dialog {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	// padding: 0 20px;
	// dialog
	.up-input {
		width: 140px;
	}
	.icon-font {
		padding: 5px 10px;
		margin-left: 10px;

		i {
			cursor: pointer;
		}
	}
}
</style>
